import type { ExtendedError } from 'factories/api';
import type { NormalizedSchema } from 'normalizr';
import type { XhrStatus } from 'redux/reusable/xhrStatus';
import { createXhrStatusModule } from 'redux/reusable/xhrStatus';
import type { Tag, TagBase } from 'types/tag';
import { actionCreatorFactory } from 'typescript-fsa';

const actionCreator = actionCreatorFactory('timely/tags');

export type NormalizedTagsListSchema = NormalizedSchema<TagsEntities, Array<number>>;
type NormalizedTagSchema = NormalizedSchema<TagsEntities, number>;

export type TagNormalized = Omit<Tag, 'children'> & { children: Array<number> };

export type TagsDictionary = { [id: number]: TagNormalized };
export type TagsWithChildrenDictionary = { [id: number]: Tag };

export interface TagsEntities {
  tag: TagsDictionary;
}

export type TagDraft = Omit<Tag, 'id' | 'children' | 'name'> & Partial<TagBase>;

export interface TagsState {
  draft?: TagDraft;
  entities: TagsEntities;
  error?: ExtendedError;
  result: Array<number>;
  showEditor: boolean;
  xhrStatus: XhrStatus;
}

export interface TagList {
  id: number;
  label_id: number;
  name: string;
  required: boolean;
  sequence: number;
  active?: boolean;
  children?: Array<number>;
}

export const receiveTags = actionCreator.async<void, NormalizedTagsListSchema, ExtendedError>(
  'FETCH_TAGS'
);
export const updateTags = actionCreator<NormalizedTagsListSchema>('UPDATE_TAGS');
export const deleteTag = actionCreator.async<{ tagId: number }, void, ExtendedError>('DELETE');
export const tagDeleted = actionCreator<number>('TAG_DELETED');

export const savedTag = actionCreator<NormalizedTagSchema>('SAVED');
export const errorSavingTag = actionCreator<{ error: ExtendedError }>('ERROR_SAVING_TAG');

export const createTagDraft = actionCreator<TagDraft | undefined>('CREATE_DRAFT');
export const clearTagDraft = actionCreator('CLEAR_DRAFT');
export const updateTagDraft = actionCreator<TagDraft>('UPDATE_DRAFT');

export const { withXhrStatusReducer, wrapFetching, wrapSaving } = createXhrStatusModule('tags');
